import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './hero-banner-plus.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';

const jsonConverter = {
    fromAttribute: (v) => {
        try {
            return v ? JSON.parse(v) : undefined;
        }
        catch (_a) {
            return undefined;
        }
    },
    toAttribute: () => null,
};
class HeroBannerPlus extends s {
    constructor() {
        super(...arguments);
        this.isRtl = '';
        this.imageSrc = '';
        this.imageAlt = '';
        this.title = '';
        this.description = '';
        this.styleVariation = 'burgundy';
        this.isPriority = false;
        this.aspectRatio = '16:9';
        this.headingId = 'hero-title';
        this.updateAspectRatio = () => {
            this.aspectRatio = window.innerWidth >= 1440 ? '21:9' : '16:9';
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateAspectRatio();
        window.addEventListener('resize', this.updateAspectRatio);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('resize', this.updateAspectRatio);
    }
    renderImage() {
        if (!this.imageSrc)
            return w;
        return $ `<div class="hero-image"><generic-image src="${this.imageSrc}" alt="${this.imageAlt}" aspect-ratio="${this.aspectRatio}" loading="${this.isPriority ? 'eager' : 'lazy'}" fetchpriority="${this.isPriority ? 'high' : 'auto'}"></generic-image></div>`;
    }
    computeColor() {
        switch (this.styleVariation) {
            case 'purple':
            case 'night':
                return 'purple';
            case 'burgundy':
            default:
                return 'burgundy';
        }
    }
    renderCta(cta, color, styleType, className) {
        var _a;
        if (!(cta === null || cta === void 0 ? void 0 : cta.title) || !(cta === null || cta === void 0 ? void 0 : cta.url))
            return w;
        return $ `<generic-button-updated class="${className}" type="secondary" .color="${color}" .styleType="${styleType}" .label="${cta.title}" .href="${cta.url}" .target="${(_a = cta.target) !== null && _a !== void 0 ? _a : ''}" .isNoFollow="${!!cta.isNoFollow}" .ariaList="${cta.ariaLabel ? { 'aria-label': cta.ariaLabel } : {}}"></generic-button-updated>`;
    }
    renderCtas() {
        var _a, _b, _c, _d;
        const hasPrimary = !!(((_a = this.primaryButton) === null || _a === void 0 ? void 0 : _a.title) && ((_b = this.primaryButton) === null || _b === void 0 ? void 0 : _b.url));
        const hasSecondary = !!(((_c = this.secondaryButton) === null || _c === void 0 ? void 0 : _c.title) && ((_d = this.secondaryButton) === null || _d === void 0 ? void 0 : _d.url));
        if (!hasPrimary && !hasSecondary)
            return w;
        return $ `<div class="hero-ctas" role="group" aria-labelledby="${this.headingId}">${this.renderCta(this.primaryButton, this.computeColor(), 'light', 'cta-primary')} ${this.renderCta(this.secondaryButton, this.computeColor(), 'dark', 'cta-secondary')}</div>`;
    }
    render() {
        return $ `<section class="hero-banner variation-${this.styleVariation}" aria-labelledby="${this.headingId}" dir="${this.isRtl === 'isRtl' ? 'rtl' : 'ltr'}">${this.renderImage()}<div class="hero-content-container"><h2 id="${this.headingId}" class="hero-title">${o(this.title)}</h2><p class="hero-description">${o(this.description)}</p>${this.renderCtas()}</div></section>`;
    }
}
HeroBannerPlus.styles = css_248z;
__decorate([
    e({ type: String })
], HeroBannerPlus.prototype, "isRtl", void 0);
__decorate([
    e({ type: String })
], HeroBannerPlus.prototype, "imageSrc", void 0);
__decorate([
    e({ type: String })
], HeroBannerPlus.prototype, "imageAlt", void 0);
__decorate([
    e({ type: String })
], HeroBannerPlus.prototype, "title", void 0);
__decorate([
    e({ type: String })
], HeroBannerPlus.prototype, "description", void 0);
__decorate([
    e({ attribute: 'primarybutton', converter: jsonConverter })
], HeroBannerPlus.prototype, "primaryButton", void 0);
__decorate([
    e({ attribute: 'secondarybutton', converter: jsonConverter })
], HeroBannerPlus.prototype, "secondaryButton", void 0);
__decorate([
    e({ type: String })
], HeroBannerPlus.prototype, "styleVariation", void 0);
__decorate([
    e({ type: Boolean })
], HeroBannerPlus.prototype, "isPriority", void 0);
__decorate([
    t()
], HeroBannerPlus.prototype, "aspectRatio", void 0);
customElements.define('hero-banner-plus', HeroBannerPlus);

export { HeroBannerPlus };
